import { Link } from "react-router-dom";
//old import { useEffect, useState } from "react";
import { useEffect, useRef, useState } from "react";
//old import { Info } from "lucide-react";
//old import { Info, RefreshCw, AlertTriangle } from "lucide-react";
import { Info, RefreshCw, AlertTriangle, KeyRound } from "lucide-react";
import api from "../../api/api";
//old import { Panel, Stat, formatMonth, useOrgStyles } from "../../components/org/orgUi";
//old import { Panel, Stat, formatDate, useOrgStyles } from "../../components/org/orgUi";
import { Alert, Panel, Stat, apiError, formatDate, useOrgStyles, LICENSE_TYPE_LABEL } from "../../components/org/orgUi";
import { useOrgPortal } from "./orgPortalContext";
import LicensePaymentBanner from "../../components/org/LicensePaymentBanner";
import { monthEnd } from "./OrgLicenses";
import NonprofitProofBanner from "../../components/org/NonprofitProofBanner";
import { EmailText } from "./OrgStudents";

export default function OrgOverview() {
    //old const { org, isOrgAdmin, goTo } = useOrgPortal();
    //old const { orgId, org, isOrgAdmin, goTo } = useOrgPortal();
    //old const { orgId, org, isOrgAdmin, isPlatformAdmin, goTo } = useOrgPortal();
    const { orgId, org, isOrgAdmin, isPlatformAdmin, goTo, reloadOrg } = useOrgPortal();
    const s = useOrgStyles();
    //old const now = new Date();
    //old const periodLabel = formatMonth(`${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`);
    // Seats = the limit Pono Pilot set + seats added through license requests (paid or free)
    const coachSeats = org.CoachLicenseLimit + (org.CoachLicensesPurchased || 0);
    const studentSeats = org.StudentLicenseLimit + (org.StudentLicensesPurchased || 0);

    // Plans and bought seats, for the renewal / expiring-soon box (org admins only)
    const [requests, setRequests] = useState([]);
    useEffect(() => {
        if (!isOrgAdmin) return undefined;
        let cancelled = false;
        api.get(`/org/${orgId}/license-requests`)
            .then((res) => { if (!cancelled) setRequests(res.data.requests || []); })
            .catch(() => { /* the overview works without it */ });
        return () => { cancelled = true; };
    }, [orgId, isOrgAdmin]);

    // Client licenses and none assigned this month (Alicia, Oct 30): the prompt at the top takes them to the
    // Assign a license box below (on a phone it's often out of view)
    const assignInput = useRef(null);
    const noneAssigned = isOrgAdmin && !isPlatformAdmin && studentSeats > 0 && !org.StudentLicensesUsed;
    const toAssign = () => {
        const box = assignInput.current;
        if (!box) return;
        box.scrollIntoView({ behavior: "smooth", block: "center" });
        box.focus({ preventScroll: true });
    };

    return (
        <div className="space-y-6">
            {noneAssigned && (
                <div role="status" className={`flex flex-col gap-3 rounded-2xl border p-4 text-sm sm:flex-row sm:items-center sm:justify-between ${s.dark ? "border-amber-800 bg-amber-900/20" : "border-amber-200 bg-amber-50"}`}>
                    <p className={`flex items-start gap-2 ${s.text}`}>
                        <KeyRound size={16} className="mt-0.5 flex-shrink-0 text-amber-500" aria-hidden="true" />
                        <span>
                            <strong>{studentSeats === 1 ? "You have 1 client license and it isn't assigned yet."
                                : `You have ${studentSeats} client licenses and none are assigned yet.`}</strong>
                            {" "}Enter a client's email to give them one.
                        </span>
                    </p>
                    <button type="button" className={`${s.btnPrimary} flex-shrink-0`} onClick={toAssign}>Assign a license</button>
                </div>
            )}
            {isOrgAdmin && <NonprofitProofBanner org={org} onOpen={() => goTo("settings")} />}
            {org.OrgType === "education" && (
                <div className={`flex items-start gap-3 rounded-2xl border p-4 text-sm ${s.subPanel}`}>
                    <Info size={18} className={`mt-0.5 flex-shrink-0 ${s.muted}`} />
                    <p className={s.body}>
                        {/* old Education organizations can run programs and invite students for free. Viewing student details */}
                        Education organizations can run programs and invite clients for free. Viewing client details
                        (resume reviews, quarterly results, program progress) is available on the Enterprise plan.
                        {/* old Contact Pono Pilot to upgrade. */}
                        {/* upgrading is the organization's call, so not for coaches */}
                        {/* old {isOrgAdmin && " Contact Pono Pilot to upgrade."} */}
                        {/* Pono Pilot admins are the ones who change it */}
                        {/* old {isOrgAdmin && !isPlatformAdmin && " Contact Pono Pilot to upgrade."} */}
                        {/* asked for on the Requests page (Evan, Oct 16: all of an org's requests in one place) */}
                        {isOrgAdmin && !isPlatformAdmin && <>{" "}
                            <button type="button" className={s.btnLink} onClick={() => goTo("requests", { feature: "other" })}>Send us a request</button> to upgrade.</>}
                        {isPlatformAdmin && <> Change its type in <Link className={s.btnLink} to="/admin/organizations">Admin → Organizations</Link>.</>}
                    </p>
                </div>
            )}
            {/* (org: for what it has once they're paid, the Licenses page's '50 in all (25 free + 25 paid)') */}
            {isOrgAdmin && <LicensePaymentBanner org={org} requests={requests} onOpen={() => goTo("licenses")} />}
            {isOrgAdmin && org.ExpiringPurchasedSeats > 0 && (
                <div role="status" className={`flex flex-col gap-3 rounded-2xl border p-4 text-sm sm:flex-row sm:items-center sm:justify-between ${s.dark ? "border-amber-800 bg-amber-900/20" : "border-amber-200 bg-amber-50"}`}>
                    <p className={s.text}>
                        <strong>{org.ExpiringPurchasedSeats} license{org.ExpiringPurchasedSeats === 1 ? "" : "s"}</strong> you bought end this month. Renew to keep them next month.
                    </p>
                    <button type="button" className={s.btnPrimary} onClick={() => goTo("licenses")}>Review and renew</button>
                </div>
            )}
            {/* the organization's own admins (coaches and Build My Biz Brand admins looking in see the page as before) */}
            {isOrgAdmin && !isPlatformAdmin && (
                <AssignLicenseCard orgId={orgId} seats={studentSeats} used={org.StudentLicensesUsed || 0} inputRef={assignInput}
                                   onAssigned={reloadOrg} onMore={() => goTo("licenses")} onStudents={() => goTo("students")} />
            )}
            <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
                {/* old <Stat label="Students" value={org.StudentCount} hint="On your roster" /> */}
                <Stat label="Clients" value={org.StudentCount} hint="On your roster" />
                <Stat label="Programs" value={`${org.ProgramCount} / ${org.ProgramLimit}`}
                      tone={org.ProgramCount >= org.ProgramLimit ? "warn" : "default"} hint="Active / allowed" />
                <Stat label="Coach licenses" value={`${org.CoachLicensesUsed} / ${coachSeats}`}
                      hint="Assignments this month" tone={org.CoachLicensesUsed >= coachSeats ? "warn" : "default"} />
                {/* old <Stat label="Student licenses" value={`${org.StudentLicensesUsed} / ${studentSeats}`} */}
                <Stat label="Client licenses" value={`${org.StudentLicensesUsed} / ${studentSeats}`}
                      hint="Assignments this month" tone={studentSeats > 0 && org.StudentLicensesUsed >= studentSeats ? "warn" : "default"} />
            </div>
            {isOrgAdmin && <Renewals requests={requests} onOpen={() => goTo("licenses")} />}
            <Panel title="Get started">
                <ol className={`space-y-3 text-sm ${s.body}`}>
                    {/* old <li><strong className={s.text}>1. Create a program.</strong> Each program gets an invitation code students enter under My Coaching → Programs.{" "} */}
                    {/* coaches can only look, so their first two steps just point to the pages */}
                    {/* old <li><strong className={s.text}>1. {isOrgAdmin ? "Create a program." : "See the programs."}</strong> Each program gets an invitation code students enter under My Coaching → Programs.{" "} */}
                    {/* no invitation code (Alicia, Oct 30): clients are put in a program by the organization */}
                    {/* (and a new organization already has its default program, so it isn't told to create one) */}
                    <li><strong className={s.text}>1. {isOrgAdmin ? "Check your programs." : "See the programs."}</strong> Clients added to a program see it under My Coaching → Programs.{" "}
                        <button type="button" className={s.btnLink} onClick={() => goTo("programs")}>Programs</button></li>
                    {/* old <li><strong className={s.text}>2. Add students.</strong> Share the code, or import a list of emails.{" "} */}
                    {/* old <li><strong className={s.text}>2. Add students.</strong> Upload your roster, then hand out each student's license code.{" "} */}
                    {/* old <li><strong className={s.text}>2. {isOrgAdmin ? "Add students." : "See the students."}</strong> {isOrgAdmin ? "Upload your roster, then hand out each student's license code." : "Everyone on your organization's roster."}{" "} */}
                    <li><strong className={s.text}>2. {isOrgAdmin ? "Add clients." : "See the clients."}</strong> {isOrgAdmin ? "Upload your roster, then hand out each client's license code." : "Everyone on your organization's roster."}{" "}
                        {/* old <button type="button" className={s.btnLink} onClick={() => goTo("students")}>Students</button></li> */}
                        <button type="button" className={s.btnLink} onClick={() => goTo("students")}>Clients</button></li>
                    {isOrgAdmin && (
                        <li><strong className={s.text}>3. Assign licenses.</strong> Licenses run from the 1st to the end of each month.
                            A license you remove can't go to someone else until next month.{" "}
                            <button type="button" className={s.btnLink} onClick={() => goTo("licenses")}>Licenses</button></li>
                    )}
                    {/* old <li><strong className={s.text}>{isOrgAdmin ? "4" : "3"}. Review progress.</strong> Students choose what to share with your coaches */}
                    <li><strong className={s.text}>{isOrgAdmin ? "4" : "3"}. Review progress.</strong> Clients choose what to share with your coaches
                        (resume, quarterly results, program progress).</li>
                </ol>
                {org.SponsoredStudentTierName && (
                    <p className={`mt-4 text-xs ${s.muted}`}>
                        {/* old Licensed students get the {org.SponsoredStudentTierName} plan while their license is active. */}
                        Licensed clients get the {org.SponsoredStudentTierName} plan while their license is active.
                    </p>
                )}
            </Panel>
        </div>
    );
}

/**
 * When licenses renew or run out: each automatic-payment plan ("renews on" its
 * next payment date, or "ends on" the last day of that month once renewal is
 * off). Hidden when there's no plan. Bought seats that end this month are the
 * banner above (with its Review and renew button), not repeated here.
 */
function Renewals({ requests, onOpen }) {
    const s = useOrgStyles();
    const plans = requests.filter((r) => r.Status === "active" && r.AutoRenews);
    if (plans.length === 0) return null;
    const warnIcon = <AlertTriangle size={16} className="mt-0.5 flex-shrink-0 text-amber-500" />;
    return (
        <Panel title="Renewals" actions={<button type="button" className={s.btnLink} onClick={onOpen}>Licenses</button>}>
            <ul className={`space-y-3 text-sm ${s.body}`}>
                {plans.map((r) => (
                    <li key={r.RequestID} className="flex items-start gap-2">
                        {r.CancelAtPeriodEnd ? warnIcon : <RefreshCw size={16} className={`mt-0.5 flex-shrink-0 ${s.muted}`} />}
                        {r.CancelAtPeriodEnd ? (
                            <span>
                                {/* old <strong className={s.text}>{r.Quantity} {r.LicenseType} licenses</strong> end on{" "} */}
                                {/* (the plan's paid ones, as the Licenses page says: the free or included ones stay) */}
                                {/* old <strong className={s.text}>{r.Quantity} paid {r.LicenseType} licenses</strong> end on{" "} */}
                                <strong className={s.text}>{r.Quantity} paid {LICENSE_TYPE_LABEL[r.LicenseType]} licenses</strong> end on{" "}
                                <strong className={s.text}>{r.CurrentPeriodEnd ? formatDate(monthEnd(r.CurrentPeriodEnd)) : "the end of the paid period"}</strong>, renewal is off.
                            </span>
                        ) : (
                            <span>
                                {/* old <strong className={s.text}>{r.ScheduledQuantity ?? r.Quantity} {r.LicenseType} licenses</strong>{" "} */}
                                {/* old <strong className={s.text}>{r.ScheduledQuantity ?? r.Quantity} paid {r.LicenseType} licenses</strong>{" "} */}
                                <strong className={s.text}>{r.ScheduledQuantity ?? r.Quantity} paid {LICENSE_TYPE_LABEL[r.LicenseType]} licenses</strong>{" "}
                                {r.CurrentPeriodEnd ? <>renew on <strong className={s.text}>{formatDate(r.CurrentPeriodEnd)}</strong>.</> : "renew automatically."}
                            </span>
                        )}
                    </li>
                ))}
            </ul>
        </Panel>
    );
}

/**
 * Assign a license (Alicia, Oct 30: an email box with the licenses left and an Assign license button on
 * the first page after login, so an organization uses its licenses and buys more). The email is added to
 * the organization's clients (or found there) and given a license, and we email them their link to join
 * (JJ, Nov 1), so the organization doesn't hand out the code itself. With no license left, the way to get
 * more instead (the Licenses page). The numbers are the Student licenses tile's: seats minus this month's
 * assignments.
 */
function AssignLicenseCard({ orgId, seats, used, inputRef, onAssigned, onMore, onStudents }) {
    const s = useOrgStyles();
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const [done, setDone] = useState(null); // what the last Assign did: the server's answer
    const available = Math.max(0, seats - used);

    const submit = async (e) => {
        e.preventDefault();
        if (busy || !email.trim()) return;
        setBusy(true);
        setError("");
        setDone(null);
        try {
            const res = await api.post(`/org/${orgId}/clients`, { email: email.trim(), assignLicense: true });
            setDone(res.data);
            setEmail("");
            await onAssigned();
        } catch (err) {
            setError(apiError(err));
            // none left after all (another admin took the last one): the box turns into Get more licenses
            if (err?.response?.data?.code === "NO_SEATS") await onAssigned();
        } finally {
            setBusy(false);
        }
    };

    const studentsLink = <button type="button" className={s.btnLink} onClick={onStudents}>Clients</button>;
    const moreButton = <button type="button" className={s.btnPrimary} onClick={onMore}>Get more licenses</button>;
    return (
        <Panel title="Assign a license">
            <Alert onClose={() => setError("")}>{error}</Alert>
            {done && (done.alreadyLicensed ? (
                <div role="status" className={`mb-4 flex items-start gap-2 rounded-xl border px-4 py-3 text-sm ${s.subPanel} ${s.body}`}>
                    <Info size={16} className={`mt-0.5 flex-shrink-0 ${s.muted}`} />
                    <span>
                        <strong className={`${s.text} [overflow-wrap:anywhere]`}><EmailText email={done.email} /></strong> already has a license this month, so none was used.
                        {!done.joined && <> Their code and join link are on the {studentsLink} page.</>}
                    </span>
                </div>
            ) : (
                <Alert kind="success" onClose={() => setDone(null)}>
                    License assigned to <strong className="[overflow-wrap:anywhere]"><EmailText email={done.email} /></strong>.
                    {done.emailed > 0 && (done.joined
                        ? " It's on their account now, and we emailed them to let them know."
                        : " We emailed them a link to join.")}
                    {!done.emailed && <> Their code and join link are on the {studentsLink} page.</>}
                </Alert>
            ))}
            {seats === 0 ? (
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <p className={`text-sm ${s.body}`}>Your organization doesn't have client licenses yet.</p>
                    {moreButton}
                </div>
            ) : available === 0 ? (
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <p className={`text-sm ${s.body}`}>
                        {seats === 1 ? "Your client license is assigned this month."
                            : <>All <strong className={s.text}>{seats}</strong> client licenses are assigned this month.</>}
                    </p>
                    {moreButton}
                </div>
            ) : (
                <>
                    <p className={`text-sm ${s.body}`}>
                        <strong className={s.text}>{available}</strong> of {seats} client license{seats === 1 ? "" : "s"} available this month.
                    </p>
                    <form onSubmit={submit} noValidate className="mt-3 flex flex-col gap-2 sm:flex-row">
                        <label htmlFor="assign-license-email" className="sr-only">Client's email</label>
                        <input ref={inputRef} id="assign-license-email" type="email" inputMode="email" autoComplete="off" spellCheck={false}
                               placeholder="client@example.com" value={email} onChange={(e) => setEmail(e.target.value)}
                               className={`${s.input} sm:flex-1`} />
                        <button type="submit" className={`${s.btnPrimary} sm:flex-shrink-0`} disabled={busy || !email.trim()} aria-busy={busy}>
                            {busy ? "Assigning…" : "Assign license"}
                        </button>
                    </form>
                    <p className={`mt-2 text-xs ${s.muted}`}>We add them to your clients and email them a link to join.</p>
                </>
            )}
        </Panel>
    );
}
